import React from "react";
import { Row, Col, Tabs } from "antd";
import PropTypes from "prop-types";
import { ReportsListContainerWrapper } from "./ReportsList";
import { NewReportsListContainerWrapper } from "./newReports";
import { ReportTableContainerWrapper } from "./ReportTable";
import { ReportsFormContainerWrapper } from "./ReportsForm";
import moment from "moment-jalaali";
import { emptyPositions } from "./../../Basic/OrganizationChart/Module";
import ReportBuilder from "./ReportsList/form/ReportBuilder";
import RenewedCalculateForm from "./ReportsList/form/common/RenewedCalculateForm";
import Form from "../Stack/History/Form/Form";

@autobind
/**
 *
 */
export default class Reports extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: null,
      formValue: {
        dateFrom: moment(moment().format("jYYYY/jM/01"), "jYYYY/jM/jD").format(
          "YYYY-MM-DD"
        ), // 2017/09/23
        dateTo: moment().format("YYYY-MM-DD"), // 2017/10/22
        year: moment(moment().format("jYYYY/01/01"), "jYYYY/jM/jD").format(
          "jYYYY"
        ),
        positions: [],
        type: "default",
        // rules: ['1', '2'],
      },
      report: false,
      showReportBuilder: false,
      reportBuilderData: undefined,
      reportBuilderTakeReport: false,
      updateNewReportsData: false,
      activeTabKey: "default reports",
    };
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
    app.dispatch(emptyPositions());
  }

  _onClick(value) {
    this.setState({ activeItem: value });
  }

  _onSetFormValue(formValue) {
    this.setState({
      formValue: {
        ...formValue,
        positions:
          formValue.positions.length > 0
            ? formValue.positions
            : this.state.Positions,
      },
      report: true,
    });
  }

  _onCancel() {
    this.setState({
      activeItem: null,
      formValue: {},
      report: false,
      activeTabKey: "default reports",
    });
  }

  showReportBuilder = (value) => {
    this.setState({ reportBuilderData: value, showReportBuilder: true });
  };

  _onCancelReportBuilder() {
    this.setState({
      showReportBuilder: false,
      reportBuilderData: null,
      activeItem: this.state.activeItem,
      report: false,
    });
  }

  // showCreateForm =(value)=>{
  //   this.setState({showCreateForm: true , activeItem: value})
  // }

  handleCreateReport = (value) => {
    // update list
    // let {activeNewForm} = this.state;
    // activeNewForm={...value}
    this.setState(
      {
        showReportBuilder: false,
        reportBuilderData: null,
        updateNewReportsData: true,
      },
      () => {
        this.setState({ updateNewReportsData: false });
      }
    );
  };
  //mehdilotfee
  _onCancelTakeReport = (value) => {
    this.setState({
      activeItem: value,
      report: false,
      reportBuilderTakeReport: false,
    });
  };

  activeRenewedCalculateForm = () => {
    this.setState((prevState) => {
      return { renewedCalculateForm: !prevState.renewedCalculateForm };
    });
  };
  componentDidMount() {
    const { params } = this.props;
    const CurrentUser = JSON.parse(localStorage.getItem("CurrentUser"));
    console.log("CurrentUser", CurrentUser);
    this.setState({
      Positions: CurrentUser?.map((el) => el?.id),
    });
  }
  /**
   *
   * @return {XML}
   */

  render() {
    const {
      activeItem,
      report,
      formValue,
      showReportBuilder,
      reportBuilderData,
      reportBuilderTakeReport,
      updateNewReportsData,
      renewedCalculateForm,
      activeTabKey,
    } = this.state;
    console.log("formVformValuealue", formValue);
    console.log("activeIactiveItemtem", activeItem);
    console.log("sddsdffsd", this.state.Positions);

    return (
      <Row
        style={{
          overflowY: "auto",
          height: "100%",
          margin: 0,
        }}
      >
        {!report &&
          (app.can("Rule@getByCompanyCode") ||
            app.can("ReportBuilder@index")) && (
            <Col
              sm={24}
              md={8}
              style={{
                overflowY: "auto",
                height: "100%",
              }}
            >
              <Tabs
                defaultActiveKey={activeTabKey}
                style={{
                  minHeight: "400px",
                  height: "100%",
                  background: "white",
                }}
                onChange={(tabKey) => {
                  if (tabKey === "default reports") {
                    this._onCancel();
                  } else {
                    this._onCancelReportBuilder();
                  }
                }}
              >
                {app.can("Rule@getByCompanyCode") && (
                  <Tabs.TabPane
                    tab={app.translate("گزارشات پیش فرض")}
                    key="default reports"
                  >
                    <Row>
                      <Col xs={24}>
                        <ReportsListContainerWrapper
                          onClick={this._onClick}
                          activeItem={activeItem && activeItem.id}
                        />
                      </Col>
                    </Row>
                  </Tabs.TabPane>
                )}
                {/*app.can('ReportBuilder@index') &&
            <Tabs.TabPane
                tab={app.translate('گزارشات جدید')}
                key="report builder"
            >
              <Row>
                <Col xs={24}>
                  <NewReportsListContainerWrapper
                      onClick={(value) => {
                        if(app.can('ReportBuilder@show'))
                          this.showReportBuilder(value)
                      }}
                      activeRenewedCalculateForm={this.activeRenewedCalculateForm}
                      onTakeReport={(item) => {
                        this.setState({
                          reportBuilderTakeReport: true,
                          activeItem: item,
                          report: true,
                          showReportBuilder: false
                        })
                      }}
                      updateData={updateNewReportsData}
                      onDeleteHandle={this.handleCreateReport}
                      // onCreateForm={this.showCreateForm}
                  />
                </Col>
              </Row>
            </Tabs.TabPane>
                    */}
              </Tabs>
            </Col>
          )}

        {!!activeItem && !report && !reportBuilderData && (
          <Col
            sm={24}
            md={8}
            style={{
              overflowY: "auto",
              height: "100%",
            }}
          >
            <ReportsFormContainerWrapper
              item={activeItem}
              onClick={this._onSetFormValue}
              onCancel={this._onCancel}
              formValue={formValue}
            />
          </Col>
        )}
        {(!app._.isEmpty(formValue) || reportBuilderTakeReport) &&
          !!activeItem &&
          report && (
            <Col
              sm={24}
              style={{
                overflowY: "auto",
                height: "100%",
              }}
            >
              <ReportTableContainerWrapper
                onCancel={this._onCancelReportBuilder}
                params={formValue}
                report={activeItem}
                reportBuilder={reportBuilderTakeReport}
              />
            </Col>
          )}

        {renewedCalculateForm && (
          <RenewedCalculateForm
            visible={renewedCalculateForm}
            onCancel={this.activeRenewedCalculateForm}
            handleSubmit={this.activeRenewedCalculateForm}
          />
        )}
      </Row>
    );
  }
}
